import { useParams } from 'react-router-dom-v5-compat';

import type { GetRouteParams, Route } from 'lib/namedRoutes';

/**
 * Wrapper around react-router useParams to provide typing from our named routes.
 */
const useRouteParams = <R extends Route<any>>() => {
  const params = useParams<GetRouteParams<R>>();

  return params as GetRouteParams<R>;
};

export default useRouteParams;
